import { useEffect, useRef, useState } from 'preact/hooks';
import styles from './styles.module.scss';
import { FunctionalComponent } from 'preact';

const gradients = [
  'linear-gradient(45deg, #e20b8c, #f84b00)', // Orange to Red
  'linear-gradient(45deg, #0061ff, #0dd2e8)', // Blue to Cyan

  'linear-gradient(45deg, #a106f4, #e707fa)', // Teal to Lime Green
  'linear-gradient(45deg, #f756aa, #f75672)', // Purple to Turquoise
  'linear-gradient(45deg, #ff0f7b, #f89b29)', // Red to Yellow
  'linear-gradient(45deg, #8711c1, #2472fc)', // Royal Blue to Dark Blue
  'linear-gradient(45deg, #82f4b1, #30c67c)', // Dark Blue to Navy Blue
  'linear-gradient(45deg, #456fe8, #19b0ec)', // Dark Blue to Navy Blue
];

interface Props {
  thumbnail: string;
  titleShort: string;
  onClick: () => void;
  isViewed?: boolean;
  timestamp?: Date;
  id: string;
}

const FeedCircle: FunctionalComponent<Props> = ({
  thumbnail,
  titleShort,
  onClick,
  isViewed = false,
  timestamp = new Date(),
  id,
}: Props) => {
  const ref = useRef(null) as any;

  // True if the story was published within the last 24 hours
  const isRecentlyPublished =
    new Date(timestamp) > new Date(Date.now() - 24 * 60 * 60 * 1000);

  // const [videoLoaded, setVideoLoaded] = useState(false);

  // useEffect(() => {
  //   const videoUrl = `https://assets.oceanhero.today/feed/${id}-thumbnail.mp4`;

  //   const video = document.createElement('video');
  //   video.src = videoUrl;
  //   video.muted = true;
  //   video.autoplay = true;
  //   video.loop = true;

  //   // console.log('videoUrl', videoUrl);

  //   video.oncanplaythrough = () => {
  //     setVideoLoaded(true);
  //     video.remove();
  //   };
  // }, []);

  // Draw a gradient ring
  useEffect(() => {
    const canvas = ref.current as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    // Set height and width to 150
    canvas.width = 150;

    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = 50;
    const lineWidth = 5;
    let animationFrameId: number;

    function draw(currentTime) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const timeOffset = currentTime * 0.0002; // Adjust speed if needed

      // Create gradient (dynamic color stop positions)
      const grd = ctx.createLinearGradient(0, 0, 200, 0);
      grd.addColorStop(timeOffset % 1, !isViewed ? '#0061ff' : '#00000050');
      grd.addColorStop(
        (timeOffset + 0.5) % 1,
        !isViewed ? '#0dd2e8' : '#00000050'
      );

      // Draw the ring
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
      ctx.strokeStyle = grd;
      ctx.lineWidth = lineWidth;
      ctx.stroke();

      if (isRecentlyPublished) {
        animationFrameId = requestAnimationFrame(draw);
      }
    }

    if (!isRecentlyPublished) {
      draw(new Date().getTime());
    } else {
      animationFrameId = requestAnimationFrame(draw);
    }

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [ref, isViewed]);

  return (
    <div
      className={`${styles.storyFeedContainer} ${isViewed ? styles.storyAlreadyViewed : ''
        }`}
    >
      <button
        className={styles.storyContainerWrapper}
        onClick={() => {
          onClick();
        }}
      >
        <div
          className={styles.storyContainer}
          style={{
            backgroundImage: `url(${thumbnail})`,
            // videoLoaded && !isViewed ? null : `url(${thumbnail})`,
          }}
        >
          {/* {videoLoaded && !isViewed && (
            <video
              src={`https://assets.oceanhero.today/feed/${id}-thumbnail.mp4`}
              autoPlay
              muted
              loop
              playsInline
              style={{
                objectFit: 'cover',
                height: '48px',
                width: '48px',
                borderRadius: '50%',
              }}
            />
          )} */}
          {/* <img src={'/img/play.webp'} alt="OceanHero" /> */}
        </div>
        {/* <div className={`${styles.ring} ${isViewed ? styles.noring : ''}`} /> */}
      </button>

      <span>{titleShort}</span>

      <canvas ref={ref} />
    </div>
  );
};

FeedCircle.displayName = 'FeedCircle';

export default FeedCircle;
